import PairingInstructions from './PairingInstructions';

function PairingPinContainer({ randomPin }: { randomPin: string }) {
  return (
    <div
      aria-hidden="true"
      className="flex h-full w-full flex-col items-center justify-center gap-2 bg-primary px-4"
    >
      <div className="flex h-[30vh] flex-col items-center justify-end gap-6">
        <div className="flex flex-col gap-4 items-center">
          <div className={`flex flex-row items-center justify-center gap-2 font-ibmPlex`}>
            {randomPin.split("").map((char, index) => {
              return (
                <div
                  aria-hidden="true"
                  key={`pin_char_${index}`}
                  className="flex h-[10vw] w-[10vw] flex-1 items-center justify-center rounded-md bg-card p-2 text-center text-[7vw] font-bold uppercase md:h-[7vw] md:w-[7vw] md:text-[5vw]"
                >
                  {char}
                </div>
              );
            })}
          </div>
          <p className="text-lg text-gray-400">Your Pairing Code</p>
        </div>
      </div>
      
      <div className="max-w-md w-full">
        <PairingInstructions />
      </div>
    </div>
  );
}

export default PairingPinContainer;
